export default {
  pickerView: {
    maxWidth: 'none',
    minWidth: 'none',
    minHeight: 'none',
  },
};
